import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, PrinterIcon, PenToolIcon } from 'lucide-react';
export function SneakPeekSection() {
  return <section className="py-20 bg-transparent border-t border-mint/20" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-165">
          {/* Left Column: Video */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-166">
            <div className="absolute inset-0 bg-mint/30 rounded-3xl transform -rotate-3 scale-105 -z-10" data-id="element-167"></div>

            <div className="relative aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-168">
              <video src="https://cdn.magicpatterns.com/uploads/a5YQffqqrQ9P8SSd1drV4K/From Main Klickpin CF- Pinterest Video - 4GFK7pd7y.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-169" />
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-2xl shadow-xl border border-pink-soft/50 flex items-center gap-3 z-10" data-id="element-170">
              <div className="bg-pink-soft/50 p-3 rounded-full text-berry" data-id="element-171">
                <DownloadIcon className="w-6 h-6" data-id="element-172" />
              </div>
              <div className="text-sm font-bold text-dark" data-id="element-173">+250 Plantillas</div>
            </div>
          </motion.div>

          {/* Right Column: Text */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-174">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-6" data-id="element-175">
              No empieces desde cero.{' '}
              <span className="text-rose" data-id="element-176">Te damos las guías exactas.</span>
            </h2>
            <p className="text-lg text-muted mb-8 leading-relaxed" data-id="element-177">
              Sabemos que dar forma a las letras puede parecer intimidante al
              principio. Por eso, tu kit incluye un libro de trabajo en PDF con
              plantillas a escala real.
            </p>

            <ul className="space-y-6" data-id="element-178">
              <li className="flex items-start gap-4" data-id="element-179">
                <div className="bg-mint/20 p-3 rounded-full text-dark mt-1" data-id="element-180">
                  <PrinterIcon className="w-5 h-5" data-id="element-181" />
                </div>
                <div data-id="element-182">
                  <h4 className="font-bold text-dark text-lg" data-id="element-183">
                    Imprime en casa
                  </h4>
                  <p className="text-muted" data-id="element-184">
                    Formatos adaptados para cualquier impresora estándar.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-185">
                <div className="bg-pink-soft/60 p-3 rounded-full text-rose mt-1" data-id="element-186">
                  <PenToolIcon className="w-5 h-5" data-id="element-187" />
                </div>
                <div data-id="element-188">
                  <h4 className="font-bold text-dark text-lg" data-id="element-189">
                    Calca y moldea
                  </h4>
                  <p className="text-muted" data-id="element-190">
                    Sigue las flechas direccionales para doblar el alambre con
                    precisión milimétrica.
                  </p>
                </div>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}